import React, { Component } from 'react'
import { Panel, Container, Button, List, Toolbar, Label } from '@sencha/ext-modern'
import { compose } from 'redux'
import { connect } from 'react-redux'
import escapeRegExp from 'escape-string-regexp'
import Message from 'Tyan/components/Message'
import GroupRadioField from "Tyan/components/GroupRadioField"
import AppTitle from './AppTitle'
import { doGetAllSignedApplyTaskList, doSubmitTask } from '../../reducers/actions'
import { addListItem, getListItems, deleteListItem, changeItemsValue, hasChangedValues, getFormValue } from 'Tyan/public/utility'
import ListItem from './ListItem'
// import ExpenseTypeSelect from './ExpenseTypeSelect'

Ext.require([
  'Ext.dataview.listswiper.ListSwiper'
])

const style = {
  outer: {
    backgroundColor: "#f5f5f5",
    paddingTop: "10px",
    paddingBottom: "10px"
  },
  innerContainer: {
    borderRadius: "10px",
    backgroundColor: "#ffffff",
    margin: "10px",
  },
  titleContainer: {
    borderBottom: "1px solid #f5f5f5",
  },
  titleSmall: {
    margin: 0,
    fontSize: "14px",
  },
  contentContainer: {
    padding: "10px",
    fontSize: "12px",
    color: '#838484'
  },
  checked: {
    color: "#37a1f2",
    paddingTop: "5px"
  },
  unchecked: {
    color: "#959595",
    paddingTop: "5px"
  }
}

class MySignedApplyTask extends Component {
  state = {
    query: '',
    showSearchForPhone: false,
    loading: false,
    errorMessage: null,
    selectedTaskType: '全部',
  }

  componentDidMount() {
    const { doGetAllSignedApplyTaskList } = this.props
    doGetAllSignedApplyTaskList({
      onRequest: () => {
        this.setState({ loading: true })
      },
      onEnd: ({ errorMessage, allTaskList }) => {
        errorMessage && this.setState({ loading: false, errorMessage }) ||
          this.setState({
            loading: false, allTaskList
          })
      }
    })
  }

  //单选控件
  radioRender = ({ title, name, options, level, disabled, fieldName }) => {
    return <GroupRadioField key={name}
      disabled={disabled}
      margin={"0 0 0 " + (level * 28)}
      label={title & "：" || null}
      options={options}
      onCheck={obj => this.handlerInputChange({ name: name, value: obj.getBoxLabel(), fieldName })}
      name={name}
      checked={''}
      width="100%"
    />
  }

  handlerInputChange = ({ name, value, fieldName, onChangeed }) => {
    changeItemsValue(this, fieldName, name, value)
    onChangeed && onChangeed(value)
  }

  search = (field, value) => {
    this.setState({ query: value })
  }

  handleSearchClick = () => {
    const { showSearchForPhone } = this.state
    this.setState({ showSearchForPhone: !showSearchForPhone })
  }

  handleSelectType = (e) => {
    this.setState({ selectedTaskType: e._text })
  }

  handleChildTap = ({ id, type }) => {
    // console.log('id',id)
    // console.log('type',type)
    switch (type) {
      case '忘刷卡申请':
        location.hash = `QYWX/ForgetSwipeCardApply/${id}`
        break
      case '加班申请':
        location.hash = `QYWX/OverTimeApply/${id}`
        break
      case '请假申请':
        location.hash = `QYWX/OutApply/${id}`
        break
      case '销假申请':
        location.hash = `QYWX/LeaveCancelApply/${id}`
        break
      // case '预支申请':
      //   location.hash = `QYWX/AdvanceApply/${id}`
      //   break
      // case '报支申请':
      //   location.hash = `QYWX/ExpenseApply/${id}`
      //   break
      // case '请购申请':
      //   location.hash = `QYWX/RequisitionApply/${id}`
      //   break
      // case '采购申请':
      //   location.hash = `QYWX/PurchaseApply/${id}`
      //   break
    }
  }

  handleSubmit = (onClose) => {
    const 申请类型 = getFormValue(this, '基本信息', '申请类型')
    // if(申请类型 == '报支申请') {
    //   console.log('申请类型',申请类型)
    //   Tyan.pubForm.showDialog('报支类型', props => <ExpenseTypeSelect {...props} />)
    //   // showDetail(props => <ExpenseTypeSelect {...props} />)

    // }
    // else 
    if (申请类型) {
      onClose && onClose()
      switch (申请类型) {
        case '请假申请':
          location.hash = `QYWX/OutApply/${0}`
          break
        case '销假申请':
          location.hash = `QYWX/LeaveCancelApply/${0}`
          break
        // case '预支申请':
        //   location.hash = `QYWX/AdvanceApply/${0}`
        //   break
        // case '报支申请':
        //   location.hash = `QYWX/ExpenseApply/${0}`
        //   break
      }
    }
  }

  actDialog = ({ }) => {
    const Comp = ({ onClose }) => {
      return <>
        {this.radioRender({ name: '申请类型', level: 0, fieldName: '基本信息', options: ['请假申请', '销假申请', /* '预支申请', '报支申请', '监控调取申请单', 'FTP帐号申请', '用印申请', '外训申请单', '班车申请', '班车退订申请',  '预支申请', '报支申请'*/] })}
        <Toolbar shadow={false} docked="bottom" layout={{ type: 'hbox', pack: 'right' }}>
          <Button text={'确定'} handler={() => this.handleSubmit(onClose)} />
          <Button text={'取消'} handler={() => onClose && onClose()} />
        </Toolbar>
      </>
    }
    Tyan.pubForm.showDialog('选择申请类型', Comp, {}, {
      maxWidth: "400",
      minWidth: '300',
      scrollable: true,
      style: "'max-height: calc(100vh - 210px); overflow-y: auto;'",
    })
  }

  render() {
    const { selectedTaskType, showSearchForPhone, allTaskList, errorMessage, query } = this.state
    const panelProps = {
      height: "100%",
      margin: '0 0 0 0',
      padding: '0 0 0 0'
    }
    if (errorMessage) {
      return <Message text="数据加载失败" subText={errorMessage} />
    } else if (!allTaskList) {
      return <Message text="数据加载中..." />
    }
    let newAllTaskList = allTaskList
    if (selectedTaskType !== '全部')
      newAllTaskList = newAllTaskList.filter(item => item.title === selectedTaskType)
    if (query) {
      const match = new RegExp(escapeRegExp(query), 'i')
      newAllTaskList = newAllTaskList.filter(item => match.test(item.number) || match.test(item.title) || match.test(item.name))
    }
    return (
      <Panel shadow layout="vbox" {...panelProps}>
        <Container layout="fit" flex={0}>
          <AppTitle
            showSearchForPhone={showSearchForPhone}
            onClick={this.handleSearchClick}
            onSearch={this.search}
            allTaskList={allTaskList}
            onSelectType={this.handleSelectType}
            selectedTaskType={selectedTaskType}
          />
        </Container>
        <Panel shadow layout={{ type: 'hbox', pack: 'right' }}>
          <Button text={'添加...'} handler={() => this.actDialog({})} style={style.outer} />
        </Panel>
        <Container layout="vbox" flex={4} scrollable>
          <ListItem listData={newAllTaskList} totalCount={newAllTaskList.length} handleChildTap={this.handleChildTap} />
        </Container>
      </Panel>
    )
  }
}

const mapStateToProps = ({ }) => ({})

export default compose(
  connect(mapStateToProps, { doGetAllSignedApplyTaskList, doSubmitTask }),
)(MySignedApplyTask)
